import { getTimeslotDescription } from '@/components/PrimaryAvailability/ReservationAvailability'
import { useLocales } from '@sevenrooms/locales'
import { ReservationTimeslot, type ReservationTimeSlotVariant } from '../../../../components/ReservationTimeslot'
import type { AvailabilityTimeWithUpSellCost } from '@/hooks'

interface ReservationTimeslotsProps {
  timeslots?: AvailabilityTimeWithUpSellCost[]
  timeSlotVariant?: ReservationTimeSlotVariant
  onTimeSlotClick?: (slot: AvailabilityTimeWithUpSellCost) => void
  descriptionType?: 'short' | 'full'
  timeslotWidth: string
  currencyCode: string
}

export function ReservationTimeslots({
  timeslots,
  timeSlotVariant = 'primary',
  onTimeSlotClick,
  descriptionType,
  timeslotWidth,
  currencyCode,
}: ReservationTimeslotsProps) {
  const { formatMessage } = useLocales()
  return timeslots?.map(timeSlotInfo => (
    <ReservationTimeslot
      variant={timeSlotVariant}
      size="l"
      width={timeslotWidth}
      key={`${timeSlotInfo.time}${timeSlotInfo.accessPersistentId ?? ''}`}
      timeslotDescription={
        descriptionType === 'full'
          ? getTimeslotDescription(
              formatMessage,
              timeSlotInfo.publicTimeSlotDescription,
              timeSlotInfo.showCost,
              (timeSlotInfo.cost ?? 0) + timeSlotInfo.includedUpgradesCost,
              timeSlotInfo.chargeType,
              timeSlotInfo.duration,
              currencyCode,
              timeSlotInfo.fees
            )
          : timeSlotInfo.publicTimeSlotDescription
      }
      time={timeSlotInfo.time}
      onClick={() => {
        onTimeSlotClick?.(timeSlotInfo)
      }}
    />
  ))
}
